










import Vue from "vue";
import PricingCard from "./PricingCard.vue";

export default Vue.extend({
  name: "Pricing",
  components: { PricingCard },
  data: () => ({
    cards: [
      {
        type: "Personal",
        title: "Starter",
        price: 5,
        currency: "$",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        recommended: false,
      },
      {
        type: "Teams",
        title: "Team",
        price: 10,
        currency: "$",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        recommended: true,
      },
      {
        type: "Company",
        title: "Pro",
        price: 50,
        currency: "$",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        recommended: false,
      },
    ],
  }),
});
